import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LogQueueService } from "./services/log-queue.service";

@Injectable()
export class QueueInterceptor implements HttpInterceptor {
  constructor(private _logQueueService: LogQueueService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this._logQueueService.intercept(request, next);
  }

}
